import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { singleProp } from "@/interface/dataInterface";
import axiosInstance from "@/utils/axiosInstance";
import { FC, useState } from "react";
import { toast } from "sonner";

const DeleteVoip: FC<singleProp> = ({ prop }) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const confirmDelete = async () => {
    setLoading(true);
    try {
      await axiosInstance.delete(`/integrations/${prop}`);
      toast("Integration deleted");
    } catch (err: any) {
      toast(err.response.data.message);
    } finally {
      setLoading(false);
      setOpen(false);
    }
  };

  return (
    <>
      <Button variant="destructive" onClick={(e: React.MouseEvent) => {
        e.preventDefault()
        e.stopPropagation()
        setOpen(true)
      }}>Delete</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Are you sure you want to delete?</DialogTitle>
            <DialogDescription>
              This action can not be undone.
            </DialogDescription>
          </DialogHeader>
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)}>
              Cancel
            </Button>
            <Button onClick={confirmDelete} variant="destructive" disabled={loading}>
              {loading ? "Deleting..." : "Delete" }
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default DeleteVoip
